import {ROUTES} from 'constants/routes';
import {Loading} from 'interface/common/Loading';
import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import * as onboarding from 'store/slices/onboarding';
import {useTierOrgGenerator} from './hooks/useTierOrgGenerator';
import {OnboardSteps} from './lib/consts';

export default function TierOrganization() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {generateName} = useTierOrgGenerator();

  const createdOrgId = useSelector(
    onboarding.selectors.getCreatedOrganizationId,
  );

  const isOrgNameGenerated = useRef(false);

  const createTierOrganization = async () => {
    const {subdomain, orgName} = await generateName();
    if (subdomain && orgName) {
      dispatch(onboarding.default.actions.setOrganizationName({orgName}));
      dispatch(
        onboarding.default.actions.setSubdomain({
          subdomain,
        }),
      );
      isOrgNameGenerated.current = true;
    } else {
      navigate(
        `/${ROUTES.LOGGED_IN_WITHOUT_ORG.ONBOARDING}/${OnboardSteps.Organization}`,
      );
    }
  };

  useEffect(() => {
    if (isOrgNameGenerated.current) {
      navigate(
        `/${ROUTES.LOGGED_IN_WITHOUT_ORG.ONBOARDING}/${OnboardSteps.Payment}`,
      );
    }
  }, [isOrgNameGenerated.current]);

  useEffect(() => {
    if (!createdOrgId) {
      createTierOrganization();
    } else {
      navigate(
        `/${ROUTES.LOGGED_IN_WITHOUT_ORG.ONBOARDING}/${OnboardSteps.Payment}`,
      );
    }
  }, []);

  return <Loading centered text="Setting up your organization..." />;
}
